import { computed } from "vue";
import { getProperty } from "@/lib/helpers";
import { useStore } from "vuex";

export function useFeatureFlag(feature: string) {
  const store = useStore();

  if (!store.state.tenant && !store.state.fetchingTenant) {
    store.dispatch("fetchTenant");
  }

  const featureEnabled = computed(() => {
    if (!getProperty(store.state.tenant, "feature_flags") || !feature) {
      return false;
    } else {
      return store.state.tenant.feature_flags[feature];
    }
  });
  return featureEnabled;
}
